import { bullets as bullets_1 } from './bullets.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleBullet } from 'roosterjs-editor-api';

const bullets: RibbonButton = {
    key: 'bullets',
    title: () => loc(bullets_1),
    imageSrc: require('../svg/bullets.svg'),
    imageRtlSrc: require('../svg/bullets-rtl.svg'),
    shortcut: 'ctrl+.',
    buttonState: formatState =>
        formatState.isBullet ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleBullet(plugin.getEditor()),
};

export default bullets;
